// wiki/feature-global-nav-and-profile.md §1.

import { PUBLIC_ADMIN_HOST } from '$env/static/public';

const PRACTICE_ROUTE_PREFIXES = [
  '/archetypes',
  '/body-language',
  '/word-play',
  '/storytelling',
  '/rehearsal',
  '/active-listening',
  '/progress',
  '/library',
  '/dev-focus',
];

const BARE_ROUTES = ['/login', '/signup', '/onboarding'];

const ADMIN_ROUTE_PREFIX = '/admin';

export function isPracticeRoute(pathname: string): boolean {
  if (pathname === '/') return true;
  return PRACTICE_ROUTE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export function isBareRoute(pathname: string): boolean {
  return BARE_ROUTES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

export function isAdminRoute(pathname: string): boolean {
  return pathname === ADMIN_ROUTE_PREFIX || pathname.startsWith(`${ADMIN_ROUTE_PREFIX}/`);
}

// PUBLIC_ADMIN_HOST is the default cell's; another cell's ends its first label in `-{cell}`.
export function isAdminHost(hostname: string): boolean {
  if (hostname === PUBLIC_ADMIN_HOST) return true;
  const [adminLabel, ...adminZone] = PUBLIC_ADMIN_HOST.split('.');
  const [label, ...zone] = hostname.split('.');
  return adminLabel !== '' && label.startsWith(`${adminLabel}-`) && zone.join('.') === adminZone.join('.');
}

/** On the admin host: where a path must go, or null to render it. Only impersonation reaches product pages. */
export function adminHostRedirect(pathname: string, impersonating: boolean): string | null {
  return impersonating || isAdminRoute(pathname) ? null : ADMIN_ROUTE_PREFIX;
}

/** "<page> · VoiceDojo" → "<page>"; the bare brand → null. */
export function pageNameFromTitle(title: string): string | null {
  const brand = title.lastIndexOf(' · ');
  return brand > 0 ? title.slice(0, brand) : null;
}
